export default "__VITE_ASSET__xyHIHhRO__"